import React from 'react'

const ESDSafeMatting = () => {
    return (
        <div>
            <section class="inner-banner">
                <div class="thm-container">
                    <h2> Product Details </h2>
                    <div class="breadcumb">
                        <a href="/">ESD Lab Setup</a>
                        <i class="fa fa-angle-right"></i>
                        <span>ESD Safe Matting</span>
                    </div>
                </div>
            </section>
            <div className='container py-4'>
                <div className='row d-flex' style={{ margin: "80px 0px" }}>
                    <div className='col-lg-6 col-md-6 col-sm-12 col-xs-12'>
                        <img src='/img/esdmatting.png' width={400}></img>
                    </div>
                    <div className='col-lg-6 col-md-6 col-sm-12 col-xs-12'>
                        <h2 style={{ textDecoration: "underline" }}>ESD Safe Matting:</h2>
                        <p className="mbot25">
                            <b style={{ textDecoration: "underline", marginRight: '5px' }}>Description:</b>
                            ESD safe matting is used to cover work surfaces
                            in an ESD lab, providing a static-dissipative layer that
                            prevents electrostatic discharge. These mats are made from
                            materials that safely dissipate static charges and often
                            include grounding points. They are crucial for creating an
                            ESD-safe work environment, protecting sensitive electronic
                            components from static damage during assembly, testing,
                            and repair.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ESDSafeMatting
